import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { AppContext } from "../../../App";
import { TimestampToDateMoment } from "../../../utils/timestampToDate";

import { StyledExchangerHistory, StyledExchangerHistoryItem } from "./styledExchanger";

const ExchangerList = ({ t, exchangeHistory, updateAnimation }) => {
  const { exchanger } = useContext(AppContext);

  const { showExchanger, setShowExchanger } = exchanger;

  const toggleDrawer = () => {
    setShowExchanger(!showExchanger);
  };

  if (!exchangeHistory) {
    return null;
  }

  return (
    <StyledExchangerHistory>
      <h3 className="title">
        {t("exchanger.history.title")}
      </h3>
      {exchangeHistory && exchangeHistory.map((item, key) => (
        <StyledExchangerHistoryItem key={key} animation={key === 0 && updateAnimation}>
          <div className="exchange-item-body">
            <div className="exchange-pair-unit">
              <div>
                {item.pair.exchangePair.inService.name} {item.pair.exchangePair.inCurrency.asset}
              </div>
              <div className="exchange-pair-unit__amount">
                {item.inAmount}
              </div>
            </div>
            <div className="separator">-</div>
            <div className="exchange-pair-unit">
              <div>
                {item.pair.exchangePair.outService.name} {item.pair.exchangePair.outCurrency.asset}
              </div>
              <div className="exchange-pair-unit__amount">
                {item.outAmount}
              </div>
            </div>
          </div>
          <div className="exchange-date">
            {TimestampToDateMoment(item.createdAt)}
          </div>
        </StyledExchangerHistoryItem>
      ))}
      {exchangeHistory.length > 1 &&
        <div className="exchange-history-more">
          <NavLink to="exchange" onClick={toggleDrawer}>
            {t("exchanger.history.more")}
          </NavLink>
        </div>}
    </StyledExchangerHistory>
  );
};

export default ExchangerList;